import { useEffect } from 'react';
import { SubscriptionForm } from 'src/components/SubscriptionForm';

import { Dialog } from '@sravni/react-design-system';
import { IdleComponentProps } from '@sravni/react-ugc/lib/WithIdleWrapper';
import { useIsMobile } from '@sravni/react-utils';

import styles from './subscription-popup.module.scss';

export type PopupProps = {
  userEmail?: string;
  isEmailEditable: boolean;
  onSubscribe: (email?: string) => void;
  onVisible: (time: number) => void;
  onHide: () => void;
};

export const SubscriptionPopup = ({
  onVisible,
  onHide,
  userEmail,
  onSubscribe,
  canBeVisible,
  onClose,
  isEmailEditable,
}: PopupProps & IdleComponentProps) => {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (canBeVisible) {
      const time = Date.now();
      onVisible(time);
    } else {
      onHide();
    }
  }, [canBeVisible, onHide, onVisible]);

  const handleSubscribe = (email?: string) => {
    onSubscribe(email);
    onClose();
  };

  return (
    <Dialog closable={true} fullscreen={isMobile} visible={canBeVisible} onClose={onClose}>
      <Dialog.Content className={styles.dialogContent}>
        <SubscriptionForm userEmail={userEmail} onSubscribe={handleSubscribe} isEmailEditable={isEmailEditable} />
      </Dialog.Content>
    </Dialog>
  );
};
